export default {
  styleOverrides: {
    root: {}
  }
};
